import Vue from 'vue'

# Plugins
import Vuex from 'vuex'
import Vuetify from 'vuetify'
import 'moment-timezone'
import 'vuetify/dist/vuetify.min.css'
import VueScrollTo from 'vue-scrollto'
import truncate from 'vue-truncate-collapsed'
import { sync } from 'vuex-router-sync'

import app from './App'
import router from './router/router.coffee'
import store from './store/store.coffee'
import filters from './filters/filters.coffee'

# Stylesheets
import style from './style.css'
import '../static/fonts/Roboto/Roboto.css'
import '../static/fonts/MaterialIcons/MaterialIcons.css'
import '../static/fonts/FontAwesome4/css/font-awesome.css'

# Component imports
import Header from './components/Header'
import couponDisplay from './components/couponDisplay'
import menuHeader from './components/menu/menuHeader'
import menuFooter from './components/menu/menuFooter'
import Banner from './components/Banner'
import Content from './components/Content'
import Footer from './components/Footer'
import MenuDrawer from './components/drawers/menuDrawer/MenuDrawer'
import OrderDrawer from './components/drawers/orderDrawer/OrderDrawer'
import CouponDrawer from './components/drawers/couponDrawer/CouponDrawer'
import FeaturesDrawer from './components/drawers/featuresDrawer/FeaturesDrawer'
import MywayDrawer from './components/drawers/mywayDrawer/MywayDrawer'
import MenuMenus from './components/menu/menus'
import MenuStatic from './components/menu/menu-static'
import ExpirationView from '@/components/Expiration'
import LoadingView from '@/components/Loading'
import ErrorView from '@/components/Error'
import InformationView from '@/components/Information'
import OrderEditor2 from '@/components/editor/editor2'
import OrderCoupons from '@/components/coupons/coupons'
import OrderTipping from '@/components/tipping/tipping'
import OrderPayment from '@/components/payments/payment'
import LocationHeader from '@/components/LocationHeader'
import MapView from '@/components/Map'

# Component registration
Vue.component 'order-header', Header
Vue.component 'order-coupon-display', couponDisplay
Vue.component 'order-menu-header', menuHeader
Vue.component 'order-menu-footer', menuFooter
Vue.component 'order-banner', Banner
Vue.component 'order-content', Content
Vue.component 'order-footer', Footer
Vue.component 'order-menu-drawer', MenuDrawer
Vue.component 'order-order-drawer', OrderDrawer
Vue.component 'order-coupon-drawer', CouponDrawer
Vue.component 'order-features-drawer', FeaturesDrawer
Vue.component 'order-myway-drawer', MywayDrawer
Vue.component 'order-menu-menus', MenuMenus
Vue.component 'order-menu-static', MenuStatic
Vue.component 'expiration-view', ExpirationView
Vue.component 'loading-view', LoadingView
Vue.component 'error-view', ErrorView
Vue.component 'information-view', InformationView
Vue.component 'map-view', MapView
Vue.component 'order-editor2', OrderEditor2
Vue.component 'order-coupons', OrderCoupons
Vue.component 'order-tipping', OrderTipping
Vue.component 'order-payment', OrderPayment
Vue.component 'location-header', LocationHeader


# Third-party components
import VueGoogleAutocomplete from 'vue-google-autocomplete'
import * as VueGoogleMaps from 'vue2-google-maps'
#import GmapCustomMarker from 'vue2-gmap-custom-marker'

# Third-party component registrations
Vue.component 'vue-google-autocomplete', VueGoogleAutocomplete
#Vue.component 'gmap-custom-marker', GmapCustomMarker

# lodash
_ = require('lodash')

# Plugins
Vue.use Vuex
Vue.use Vuetify
Vue.use VueScrollTo
Vue.use truncate
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD6-qGdZj7_Nz7NTzJqrgCbycS9zr-OkZ8',
    libraries: 'places'
  }
})

# Enable syncing the router and store
# Creates store.state.route{}
unsync = sync(store, router)

# Register filters
for k, v of filters
  Vue.filter k, v

# Config
Vue.config.productionTip = false

### eslint-disable no-new ###
V = new Vue(
  el: '#app'
  router: router
  store: store
  template: '<app/>'
  components:
    App: app
)
